// src/common/TableDialog.js
import React, { useState } from 'react';
import { Box } from '@mui/system';
import { Button, DialogActions, DialogContent } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import TableViewIcon from '@mui/icons-material/TableView';
import { AppStyle, AppWord } from '../value/AppConst';
import DraggableViewer from './DraggableViewer';
import FlexyTable, { sumColumnWidth } from './flexytable/FlexyTable';
import { ContentHeader, ControlBox, CountLabel, ToolBox } from './TopViewControl';
import SearchBox from './SearchBox';

export default function TableDialog({
    open,
    title,
    startIcon=<TableViewIcon size={AppWord.LARGE} />,
    records = [],
    tableName,
    tableProps = {columns: []},
    onClose
}) {
    const [countToDisplay, setCountToDisplay] = useState(0);
    const [searchText, setSearchText] = useState('');

    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    const tableWidth = sumColumnWidth(tableProps.columns);

    const BoxStyle = {
        position:'absolute', left:0, top:0, right:0, bottom:3, 
        display:'flex', flexDirection: 'column'
    };

    return(
        <DraggableViewer
            open={open} maxWidth='lg'
            title={title}
            startIcon={startIcon}
            onClose={onClose}
        >
            <DialogContent
                style={{
                    position: 'relative',
                    minHeight:'50vh',
                    minWidth:600, width:tableWidth, maxWidth: '90vw'
                }}
            >
                <Box style={BoxStyle}>
                    <ContentHeader>
                        <ControlBox style={{paddingLeft:10}}>
                            <SearchBox
                                value={searchText}
                                onChangeText={onChangeSearchText}
                            />
                        </ControlBox>
                        <ToolBox>
                            <CountLabel count={countToDisplay} />
                        </ToolBox>
                    </ContentHeader>
                    <FlexyTable
                        name={tableName ? tableName : 'tableDialogTable'+(new Date()).getTime()}
                        tableProps={tableProps}
                        records={records}
                        hideBubble={true}
                        usePopoverBubble={false}
                        onChangeCountToDisplay={setCountToDisplay}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color={AppStyle.mui.primary}
                    variant={AppStyle.mui.contained}
                    startIcon={<DoneIcon/>}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );
}